/* ============================================================================
   NZ Blooms — PDP recipe block, selected-size behaviour.

   This script does NOT pre-select a variant. The brand asked for the theme's own
   default selection to stand, so nothing here ever changes which size is chosen.
   All it does is decide which already-rendered panel is visible.

   Every panel is rendered visible in the HTML. If this script never runs, the
   customer sees the whole ladder, which is the correct fallback — the block is
   readable with JavaScript off, and the verification pass can still count one
   panel per rung in the served markup.

   WHY THE RADIO IS NOT TRUSTED ON LOAD
   ------------------------------------
   product-swatch-new.liquid marks the FIRST radio checked in the HTML
   (`{% if forloop.first %} checked{% endif %}`) and the theme moves the checkmark to
   the real variant afterwards, without firing a change event. An earlier version of
   this file read `:checked` on DOMContentLoaded and latched "Regular" on a page
   loaded with ?variant=<Deluxe>, while the SKU, the price and the highlighted tile
   all said Deluxe. That is the handover's trap 9 in a different costume.

   So the order of authority differs by moment:
     on load        -> ?variant= on the URL, then data-selected, which Liquid rendered
                       from product.selected_or_first_available_variant (server-side,
                       always right)
     after a change -> the checked radio, which is authoritative once a human has
                       actually clicked something

   Event delegation on `document` is used on purpose: Turbo re-renders parts of the
   product form on variant change, so a listener bound directly to a radio would be
   discarded silently the first time that happened.
   ========================================================================== */
(function () {
  'use strict';

  var SIZE_RADIO = 'input[type="radio"][name^="option-"]';

  function panels(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-nzb-panel]'));
  }

  function sizeFromUrl(root) {
    var vid = new URLSearchParams(window.location.search).get('variant');
    if (!vid) return null;
    var match = root.querySelector('[data-nzb-panel][data-variant-id="' + vid + '"]');
    return match ? match.getAttribute('data-size') : null;
  }

  function sizeFromRadio(root) {
    var scope = root.closest('form') || root.closest('.product-container') || document;
    var checked = scope.querySelector(SIZE_RADIO + ':checked');
    return checked && checked.value ? checked.value : null;
  }

  function chosenSize(root, afterInteraction) {
    if (afterInteraction) {
      return sizeFromRadio(root) || sizeFromUrl(root) || root.getAttribute('data-selected');
    }
    return sizeFromUrl(root) || root.getAttribute('data-selected') || sizeFromRadio(root);
  }

  /** Header pill reports the rung on show. Liquid renders it correct on first paint. */
  function syncStems(root, panel) {
    var pill = root.querySelector('[data-nzb-stems]');
    if (!pill || !panel) return;
    var count = panel.getAttribute('data-count');
    if (count) {
      pill.textContent = count;
      pill.hidden = false;
    } else {
      // A rung with nothing countable: hide the pill rather than show an empty one.
      pill.hidden = true;
    }
  }

  function apply(root, afterInteraction) {
    if (root.getAttribute('data-mode') !== 'selected') return;

    var all = panels(root);
    if (all.length < 2) return; // one rung: nothing to switch between

    var want = chosenSize(root, afterInteraction);
    if (!want) return;

    var hit = all.filter(function (p) { return p.getAttribute('data-size') === want; });
    if (!hit.length) return; // never hide everything just because a name did not match

    root.classList.add('nzb-recipe--selected-only');
    all.forEach(function (p) { p.hidden = hit.indexOf(p) === -1; });
    syncStems(root, hit[0]);
  }

  function applyAll(afterInteraction) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nzb-recipe]'), function (root) {
      apply(root, afterInteraction === true);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SIZE_RADIO)) applyAll(true);
  });

  // Turbo and several apps announce variant changes on the document. Treat these as
  // interactions: by the time they fire, the picker state is settled.
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (evt) {
    document.addEventListener(evt, function () { applyAll(true); });
  });

  // Back/forward moves the ?variant= param, so re-read from the URL, not the radio.
  window.addEventListener('popstate', function () { applyAll(false); });

  function init() { applyAll(false); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Run once more after the theme has finished upgrading the picker. Harmless if
  // nothing changed, and it closes the gap if another script rewrites the form late.
  window.addEventListener('load', init);
})();
